import * as React from 'react'

import { observer } from 'mobx-react'

import Loading from 'modules/core/components/Loading'
import PanesHeader from 'modules/core/components/PanesHeader'
import { useUnsafeAsyncData } from 'modules/core/hooks/useAsyncData'
import i18n from 'modules/core/lib/i18n'

import type SubscriptionAddon from 'modules/billing/store/models/SubscriptionAddon'
import folders from 'modules/documents/store/collections/folders'

import Folders from '../../../../common/Folders'

interface Props {
  addon: SubscriptionAddon
}

const FoldersSettings = ({ addon }: Props) => {
  const { loading } = useUnsafeAsyncData(
    () =>
      folders.fetch({
        data: {
          billing_subscription_addon_id: addon.attributes.db_id,
          active: true,
        },
      }),
    [addon]
  )

  const foldersAvailable = !loading && !!folders.length

  return (
    <>
      <PanesHeader
        description={i18n.t('expenses.settings.folders.description')}
        illustration="folder-file"
        line={false}
        title={i18n.t('expenses.settings.folders.title')}
      />
      {loading && <Loading />}
      {foldersAvailable && <Folders folders={folders} />}
    </>
  )
}

export default observer(FoldersSettings)
